//@ts-check
if (!customElements.get('c-file-download')) {
  class FileDownload extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('a, button')
      if (!trigger) return

      trigger.addEventListener('click', (event) => {
        event.preventDefault()
        this.download()
      })
    }

    /**
     * Fetches a cross-origin Shopify CDN file and triggers a browser download.
     */
    async download() {
      const url = this.dataset.url
      if (!url) return

      const filename = this.dataset.filename || this.extractFilename(url)

      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error('Download failed')
        }

        const blob = await response.blob()
        const blobUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(blobUrl)
      } catch {
        window.open(this.withAttachmentParam(url), '_blank', 'noopener,noreferrer')
      }
    }

    /**
     * @param {string} url
     * @returns {string}
     */
    extractFilename(url) {
      try {
        const pathname = new URL(url, window.location.origin).pathname
        const segments = pathname.split('/')
        const last = segments[segments.length - 1] || 'download'
        return decodeURIComponent(last.split('?')[0])
      } catch {
        return 'download'
      }
    }

    /**
     * @param {string} url
     * @returns {string}
     */
    withAttachmentParam(url) {
      if (url.includes('attachment')) return url
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}attachment`
    }
  }

  customElements.define('c-file-download', FileDownload)
}
